/**
 *
 * File: PlannedActionsRequest.js
 *
 */
//TODO: These are actuals, not planned actions. rename this class
(function(){
    angular
        .module('maApp.remoteRequests')
        .factory('PlannedActionsRequest', PlannedActionsRequest);

    PlannedActionsRequest.$inject = ['$http', '$interpolate', 'endpoint', 'Auth', 'RequestError'];

    function PlannedActionsRequest($http, $interpolate, endpoint, Auth, RequestError){

        return {
            Planned:{
                'get':function(eventId, projectId, actionId){
                    return readEventActions(eventId, projectId, actionId, null, 'actionplans');
                },
                'post':function(eventId, data){
                    return createEventAction(eventId, data, 'actionplans');
                },
                'put':function(eventId, data){
                    return updateEventAction(eventId, data, 'actionplans');
                },
                'delete':function(eventId, data){
                    return deleteEventAction(eventId, data, 'actionplans');
                }
            },
            Actual:{
                'get':function(eventId, projectId, actionId, samplingUnitId){
                    return readEventActions(eventId, projectId, actionId, samplingUnitId, 'actionactuals');
                },
                'put':function(projectId, planId, unitId, actionId, startDate, data){
                    return updateEventAction(projectId, planId, unitId, actionId, startDate, data, 'actionactuals');
                },
                'delete':function(project, eventId, actionId, unitId, startDate){
                    return deleteEventAction(project, eventId, actionId, unitId, startDate,'actionactuals');
                }
            }

        };

        function readEventActions(eventId, projectId, actionId, samplingUnitId, actionRoute) {
            var storageName = 'PlannedActionsRequest' + (actionRoute == "actionplans" ? 'Planned' : 'Actual');
            if(!eventId) {
                throw new Error(storageName + ".get called with a falsey eventId");
            }
            if(!projectId){
                throw new Error(storageName + ".get called with a falsey projectId");
            }
            var actionIdPath = '';
            var samplingUnitIdPath = '';
            if(actionId){
                actionIdPath = actionId + "/";
            }
            if(actionId && samplingUnitId){ //must have actionId to use samplingUnitId
                samplingUnitIdPath = samplingUnitId + "/";
            }

            var templateUrl = "{{endpoint}}managementevents/{{eventId}}/{{actionRoute}}/{{actionIdPath}}{{samplingUnitIdPath}}?dataonly=1&project={{projectId}}&{{auth}}";
            var templateOptions = {
                'endpoint':endpoint,
                'auth':Auth.getUserAuthQueryStr(),
                'eventId':eventId,
                'actionIdPath':actionIdPath,
                'actionRoute':actionRoute,
                'samplingUnitIdPath':samplingUnitIdPath,
                'projectId':projectId
            };
            return $http.get(  $interpolate(templateUrl)(templateOptions)  )
                .then(readSuccess, readFail);

            function readSuccess(response){
                return response.data;
            }

            function readFail(response){
                throw new RequestError(response, $interpolate('Failed {{requestType}} fetch')({requestType:storageName}));
            }
        }

        function createEventAction(eventId, data, actionRoute) {
            if(!data) {
                throw new Error('EventCompositeActionsPlanned.post called with a falsey  "data" argument');
            }
            var templateUrl = "{{endpoint}}managementevents/{{eventId}}/{{actionRoute}}/?dataonly=1&{{auth}}";
            var templateOptions = {'endpoint':endpoint, 'auth':Auth.getUserAuthQueryStr(),'eventId':eventId, 'actionRoute':actionRoute };
            return $http({
                method: 'POST',
                url:$interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param(data)),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(createSuccess, createFail);

            function createSuccess(response){
                return response.data;
            }

            function createFail(response){
                throw new RequestError(response, 'Failed to create event action');
            }
        }

        function updateEventAction(projectId, planId, unitId, actionId, startDate, data, actionRoute) {

            if('enddate' in data && Date.create(data.enddate).isValid()){
                data.enddate = Date.create(data.enddate).format(Date.ISO8601_DATE);
            } else {
                throw new Error('EventCompositeActionsPlanned.put called with invalid  "data.enddate" argument');
            }
            if('plannedstartdate' in data){
                if(Date.create(data.plannedstartdate).isValid()){
                    data.plannedstartdate = Date.create(data.plannedstartdate).format(Date.ISO8601_DATE);
                } else {
                    throw new Error('EventCompositeActionsPlanned.put called with invalid  "data.plannedstartdate" argument');
                }
            }

            var templateUrl =
                "{{endpoint}}managementevents/{{eventId}}/{{actionRoute}}/{{actionId}}/{{unitId}}/{{startDate}}/?dataonly=1&project={{projectId}}&{{auth}}";
            var templateOptions = {
                'endpoint':endpoint,
                'auth':Auth.getUserAuthQueryStr(),
                'eventId':planId,
                'unitId':unitId,
                'actionId':actionId,
                'actionRoute':actionRoute,
                'startDate':Date.create(startDate).format(Date.ISO8601_DATE),
                'projectId':projectId
            };

            return $http({
                method: 'PUT',
                url:$interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param(data)),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(putSuccess, putFail);

            function putSuccess(response){
                return response.data;
            }

            function putFail(response){
                throw new RequestError(response, 'Failed to update event action');
            }
        }

        function deleteEventAction(project, eventId, actionId, unitId, startDate, actionRoute) {
            var templateUrl = "{{endpoint}}managementevents/{{eventId}}/{{actionRoute}}/{{actionId}}/{{unitId}}/{{startDate}}/?dataonly=1&{{auth}}";
            var templateOptions = {
                'endpoint':endpoint,
                'auth':Auth.getUserAuthQueryStr(),
                'eventId':eventId,
                'actionId':actionId,
                'actionRoute':actionRoute,
                'unitId':unitId,
                'startDate':Date.create(startDate).format(Date.ISO8601_DATE)
            };
            return $http({
                method: 'DELETE',
                url:$interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param({'project':project})),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .catch(deleteFail);

            function deleteFail(response){
                throw new RequestError(response, 'Failed to delete event action');
            }
        }

    }
})();